function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isEqual as isDateEqual, format as formatFn, isDate, isAfter, isValid, isBefore, startOfDay, startOfMonth } from 'date-fns';
import { isFunction, isArray } from '@cloud-sn/v-utils';
import { VFullCaleadar as FullCalendar } from '@cloud-sn/v-datepicker';
import { buildComponentName } from '../utils';
import Header from './header';
import CN from '../datepicker/locale/zh_CN';
export default {
  name: buildComponentName('FullCalendar'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-fullcalendar'
    },
    value: {
      type: Date,
      default: null
    },
    mode: {
      type: String,
      default: 'month',
      validator: function validator(val) {
        return ['year', 'month'].indexOf(val) > -1;
      }
    },
    fullscreen: {
      type: Boolean,
      default: true
    },
    dateCellRender: {
      type: Function,
      default: null
    },
    dateCellContentRender: {
      type: Function,
      default: null
    },
    monthCellRender: {
      type: Function,
      default: null
    },
    monthCellContentRender: {
      type: Function,
      default: null
    },
    locale: {
      type: Object,
      default: function _default() {
        return CN.lang;
      }
    },
    validRange: {
      type: Array,
      default: null
    },
    disabledDate: {
      type: Function,
      default: undefined
    }
  },
  data: function data() {
    return {
      innerValue: null,
      innerMode: ''
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          fullscreen = this.fullscreen;
      return _ref = {}, _defineProperty(_ref, prefixCls, fullscreen), _defineProperty(_ref, "".concat(prefixCls, "-fullscreen"), fullscreen), _ref;
    },
    type: function type() {
      var innerMode = this.innerMode;
      return innerMode === 'month' ? 'date' : 'month';
    },
    range: function range() {
      var validRange = this.validRange;
      var isInValid = !isArray(validRange) || validRange.length < 2;

      if (isInValid || !validRange.every(function (v) {
        return isDate(v) && isValid(v);
      })) {
        return null;
      }

      var _validRange = _slicedToArray(validRange, 2),
          start = _validRange[0],
          end = _validRange[1];

      return isAfter(start, end) ? [end, start] : validRange;
    },
    disabledFn: function disabledFn() {
      var type = this.type,
          range = this.range,
          disabledDate = this.disabledDate;
      var ret = disabledDate;

      if (range) {
        var _range = _slicedToArray(range, 2),
            start = _range[0],
            end = _range[1];

        var _ref2 = type === 'month' ? [startOfMonth(start), startOfMonth(end)] : [startOfDay(start), startOfDay(end)],
            _ref3 = _slicedToArray(_ref2, 2),
            startDate = _ref3[0],
            endDate = _ref3[1];

        ret = function ret(current) {
          if (!current) {
            return false;
          }

          var flag = isFunction(disabledDate) ? disabledDate(current) : false;

          if (!flag) {
            var currentDate = type === 'month' ? startOfMonth(current) : startOfDay(current);
            flag = isBefore(currentDate, startDate) || isAfter(currentDate, endDate);
          }

          return flag;
        };
      }

      return ret;
    }
  },
  watch: {
    value: function value(nVal) {
      var getValidValue = this.getValidValue,
          setInnerValue = this.setInnerValue;
      var validValue = getValidValue(nVal);
      setInnerValue(validValue, !isDateEqual(validValue, nVal));
    },
    mode: function mode(nVal) {
      this.setInnerMode(nVal, false);
    }
  },
  created: function created() {
    var getValidValue = this.getValidValue,
        setInnerValue = this.setInnerValue,
        setInnerMode = this.setInnerMode,
        value = this.value,
        mode = this.mode;
    var validValue = getValidValue(value);
    setInnerValue(validValue, !isDateEqual(validValue, value));
    setInnerMode(mode, false);
  },
  methods: {
    triggerPanelChange: function triggerPanelChange() {
      var innerValue = this.innerValue,
          innerMode = this.innerMode;
      this.$emit('panel-change', innerValue, innerMode);
    },
    setInnerValue: function setInnerValue(value) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var innerValue = this.innerValue;

      if (!isDateEqual(value, innerValue)) {
        this.innerValue = value;

        if (trigger) {
          this.$emit('input', value);
          this.$emit('change', value);
        }
      }
    },
    setInnerMode: function setInnerMode(mode) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.innerMode = mode;

      if (trigger) {
        this.triggerPanelChange();
      }
    },
    getValidValue: function getValidValue(value) {
      var range = this.range;
      var ret = isDate(value) && isValid(value) ? value : new Date();

      if (range) {
        var _range2 = _slicedToArray(range, 2),
            start = _range2[0],
            end = _range2[1];

        var valueDate = startOfDay(ret);
        var startDate = startOfDay(start);
        var endDate = startOfDay(end);

        if (isBefore(valueDate, startDate)) {
          ret = startDate;
        }

        if (isAfter(valueDate, endDate)) {
          ret = endDate;
        }
      }

      return ret;
    },
    getCellContentFn: function getCellContentFn(type, contentRenderFn) {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          locale = this.locale;
      var format = type === 'date' ? 'DD' : 'MMM';
      return function (_ref4) {
        var current = _ref4.current,
            value = _ref4.value;
        return h("div", {
          "class": "".concat(prefixCls, "-").concat(type)
        }, [h("div", {
          "class": "".concat(prefixCls, "-value")
        }, [formatFn(current, format, {
          locale: locale.DateFnsLocale
        })]), h("div", {
          "class": "".concat(prefixCls, "-content")
        }, [isFunction(contentRenderFn) ? contentRenderFn({
          current: current,
          value: value
        }) : null])]);
      };
    },
    getCellRenderFn: function getCellRenderFn() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'date';
      var $scopedSlots = this.$scopedSlots,
          getCellContentFn = this.getCellContentFn;
      var cellFnName = type === 'date' ? 'dateCellRender' : 'monthCellRender';
      var cellRenderFn = $scopedSlots[cellFnName] || this[cellFnName];

      if (!isFunction(cellRenderFn)) {
        var contentFnName = type === 'date' ? 'dateCellContentRender' : 'monthCellContentRender';
        cellRenderFn = getCellContentFn(type, $scopedSlots[contentFnName] || this[contentFnName]);
      }

      return cellRenderFn;
    },
    onTypeChange: function onTypeChange(type) {
      var mode = type === 'date' ? 'month' : 'year';
      this.setInnerMode(mode);
    },
    onInput: function onInput(val) {
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'calendar';
      this.setInnerValue(val);

      if (from === 'header') {
        this.triggerPanelChange();
      }
    },
    onSelect: function onSelect(val, from) {
      this.$emit('select', val, from);
    }
  },
  render: function render() {
    var h = arguments[0];
    var $props = this.$props,
        locale = this.locale,
        classes = this.classes,
        prefixCls = this.prefixCls,
        innerValue = this.innerValue,
        type = this.type,
        getCellRenderFn = this.getCellRenderFn,
        disabledFn = this.disabledFn,
        onTypeChange = this.onTypeChange,
        onInput = this.onInput,
        onSelect = this.onSelect;
    var dateCellRenderFn = getCellRenderFn('date');
    var monthCellRenderFn = getCellRenderFn('month');
    return h("div", {
      "class": classes
    }, [h(Header, {
      "props": _objectSpread({}, _objectSpread({}, $props, {
        prefixCls: prefixCls,
        value: innerValue,
        type: type
      })),
      "on": _objectSpread({}, {
        'type-change': onTypeChange,
        change: function change(val) {
          onInput(val, 'header');
        }
      })
    }), h(FullCalendar, {
      "props": _objectSpread({}, _objectSpread({}, $props, {
        value: innerValue,
        type: type,
        dateCellRender: dateCellRenderFn,
        monthCellRender: monthCellRenderFn,
        disabledDate: disabledFn,
        format: locale.name === 'zh_cn' ? 'YYYY年MM月DD日' : 'MMMM D, YYYY'
      })),
      "on": _objectSpread({}, {
        input: onInput,
        select: onSelect
      })
    })]);
  }
};